import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { EngineService } from '../engine.service';
import { NotificationService } from 'src/app/services/notification.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/redux/app.state';
import { setLoading } from 'src/app/redux/actions/user.actions';
import { Engine, Manufacturer } from 'src/typings';
import { FuelTypeEnum } from 'src/enums';

@Component({
  selector: 'app-engine-create',
  templateUrl: './engine-create.component.html',
  styleUrls: ['./engine-create.component.scss']
})
export class EngineCreateComponent {
  @Input() dialogRef: MatDialogRef<EngineCreateComponent> | undefined;

  @Input() set description(value: string) {
    this.createForm.controls.description.setValue(value);
    return;
  }

  @Input() set manufacturer(manufacturer: Manufacturer) {
    this.createForm.controls.manufacturer.setValue(manufacturer);
    return;
  }

  @Output() newEngine: EventEmitter<Engine> = new EventEmitter();

  fuelType = FuelTypeEnum;

  createForm: UntypedFormGroup = this.fb.group({
    description: new UntypedFormControl(),
    capacity: new UntypedFormControl(),
    manufacturer: new UntypedFormControl(),
    horsePower: new UntypedFormControl(),
    kW: new UntypedFormControl(),
    fuelType: new UntypedFormControl()
  });

  get manufacturerControl(): UntypedFormControl {
    return this.createForm.controls.manufacturer as UntypedFormControl;
  }

  constructor(
    private fb: UntypedFormBuilder,
    private engineService: EngineService,
    private notificationService: NotificationService,
    private store: Store<AppState>
  ) {}

  kwChange() {
    this.createForm.controls.horsePower.setValue(Math.round(this.createForm.value.kW * 1.35962));
  }

  horsePowerChange() {
    this.createForm.controls.kW.setValue(Math.round(this.createForm.value.horsePower / 1.35962));
  }

  createEngine() {
    const { description, fuelType, horsePower, kW, manufacturer, capacity } = this.createForm.value;
    this.store.dispatch(setLoading({ payload: true }));
    this.engineService
      .create({
        description,
        fuelType,
        horsePower,
        kW,
        capacity,
        manufacturer_id: manufacturer.id
      })
      .subscribe((newEngine) => {
        this.dialogRef?.close();
        this.newEngine.emit(newEngine);
        this.store.dispatch(setLoading({ payload: false }));
        this.notificationService.notice(`Двигатель ${newEngine.description} создан!`);
      });
  }
}
